<!-- signature-enrollment.component.html -->
<app-entity-mat-dialog-title
	title="Sign Enrollment"></app-entity-mat-dialog-title>

<div [ngClass]="{
        'loading-shade': showProgressSpinner
     }">

	<div mat-dialog-content>

		<mat-progress-spinner class="matProgressSpinnerCentered"
			*ngIf="showProgressSpinner" mode="indeterminate"></mat-progress-spinner>

		<form [formGroup]="this?.agreementFormGroup">

			<input class="d-none" formControlName="field_nothing">
			<!-- <input formControlName="firstName"> -->

			<!-- Use the new enrollment-agreement-display component -->
			<app-enrollment-agreement-display
				[entityData]="entityData"
				[studentAccountEntityData]="studentAccountEntityData"
				[studioInformationConfig]="studioInformationConfig"
				[enrollmentForm]="enrollmentForm"
				[isTaxInclusive]="isTaxInclusive"
				[taxConfig]="taxConfig"
				[displaySignatures]="false"
				[displayPrintButton]="false"
				[displayEmailButton]="false"
				[_enrollmentEntityData]="_enrollmentEntityData"
				[templateKey]="activeTemplateKey">
			</app-enrollment-agreement-display>

			<p class="text-center">
				<small><a class="cursor-pointer" (click)="printPage(true, false)">Click here
						to view back of agreement (fully included and opened when printed or
						emailed)</a></small>
			</p>

			<div class="container">
				<!-- Terms of Service Agreement -->
				<div class="row mt-3">
					<div class="col-12">
						<div class="border border-dark bg-secondary bg-opacity-10 p-4 rounded mt-3">
							<mat-checkbox
								[checked]="tosAccepted"
								(change)="updateTosAcceptedDate($event)"
								color="primary">
								<div style="white-space: normal; word-wrap: break-word;">
									<ng-container [ngSwitch]="activeTemplateKey">
										<ng-container *ngSwitchCase="'amdc_italian'">
											I have read and agree to this agreement, including the attached
											<a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Condizioni
												Generali del Servizio</a>.
										</ng-container>
										<ng-container *ngSwitchCase="'amdc_sydney_premium'">
											I have read and agree to this agreement, including the attached
											<a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Premium
												Dance Program Enrolment Agreement</a>.
										</ng-container>
										<ng-container *ngSwitchCase="'amdc_winnipeg'">
											I have read and agree to this agreement, including the attached
											<a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Terms
												and Conditions</a>, and acknowledge that they form part of this agreement.
										</ng-container>
										<ng-container *ngSwitchCase="'amdc_alberta'">
											I have read and agree to this agreement, including the attached
											<a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Waiver
												of Liability</a>.
										</ng-container>
										<ng-container *ngSwitchCase="'amdc_ontario'">
											I have read and agree to this agreement, including the attached
											<a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Terms
												and Conditions</a>, and acknowledge that they form part of this agreement.
										</ng-container>
										<ng-container *ngSwitchCase="'amdc_bc'">
											I have read and agree to this agreement, including the attached
											<a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Terms
												and Conditions</a>.
										</ng-container>
										<ng-container *ngSwitchCase="'amdc_quebec'">
											J'ai lu et j'accepte le pr&eacute;sent contrat, y compris les
											<a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">conditions
												et extraits de la Loi sur la protection du consommateur</a> ci-joints.
										</ng-container>
										<ng-container *ngSwitchCase="'amdc_standard'">
											This agreement is subject to and will be governed by the Terms of
											Service, which are incorporated in this agreement by reference.
											By executing this agreement, you acknowledge that you have read the Terms
											of Service and agree to abide by them.
											All references to "this agreement" mean this agreement together with the
											attached <a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Terms
												of Service</a>.
										</ng-container>
										<ng-container *ngSwitchDefault>
											I have read and agree to this agreement.
										</ng-container>
									</ng-container>
								</div>
							</mat-checkbox>
						</div>

						<div *ngIf="tosAccepted" class="mt-2 ps-4 text-success fst-italic small">
							<i class="fas fa-check-circle me-1"></i> Terms of Service accepted on {{
							(entityData?.field_tos_accepted_date ||
							enrollmentForm.get('field_tos_accepted_date')?.value) |
							date:'MMM d, y, h:mm a':'local' }}
						</div>

						<div
							*ngIf="!tosAccepted && (detectSignatureStudio || detectSignatureStudent)"
							class="mt-2 ps-4 text-danger fst-italic small">
							<i class="fas fa-exclamation-circle me-1"></i> You must accept the Terms
							of Service to proceed
						</div>
					</div>
				</div>
			</div>

			<div class="row pb-3 pt-3">
				<p *ngIf="this.entityData?.['field_sale_date']">Signed on: {{
					this.entityData?.['field_sale_date'] | date }}</p>

				<div class="col-12 col-lg-6 mb-3 mb-lg-0">
					<div class="signature-box p-3 border rounded">
						<p class="fw-bold mb-2">Studio Representative:</p>
						<div class="signature-container bg-light p-1 border rounded"
							style="min-height: 125px; touch-action: none;">
							<canvas
								*ngIf="this._enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] == null"
								width="441" height="125" class="signature-canvas w-100"
								#SignatureStudio></canvas>

							<div
								*ngIf="this._enrollmentEntityData?.['field_representative_signature']?.[0]?.['url']">
								<img class="img-fluid"
									[src]="this._enrollmentEntityData?.['field_representative_signature'][0]?.['url']" />
							</div>
						</div>
						<div class="d-flex justify-content-between align-items-center mt-2">
							<button class="mt-1" [class.display-none]="!detectSignatureStudio"
								type="button" mat-stroked-button
								(click)="signatureClearStudio()"
								*ngIf="this._enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] == null">Clear</button>
							<p class="mb-0 text-end"><span class="fw-bold">Date:</span> {{
								this.entityData?.['field_sale_date'] | date }}</p>
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-6">
					<div class="signature-box p-3 border rounded">
						<p class="fw-bold mb-2">Client Signature:</p>
						<div class="signature-container bg-light p-1 border rounded"
							style="min-height: 125px; touch-action: none;">
							<canvas
								*ngIf="this._enrollmentEntityData?.['field_signature']?.[0]?.['url'] == null"
								width="441" height="125" class="signature-canvas w-100"
								#SignatureStudent></canvas>

							<div
								*ngIf="this._enrollmentEntityData?.['field_signature']?.[0]?.['url']">
								<img class="img-fluid"
									[src]="this._enrollmentEntityData?.['field_signature'][0]?.['url']" />
							</div>
						</div>
						<div class="d-flex justify-content-between align-items-center mt-2">
							<button class="mt-1" [class.display-none]="!detectSignatureStudent"
								type="button" mat-stroked-button
								(click)="signatureClearStudent()"
								*ngIf="this._enrollmentEntityData?.['field_signature']?.[0]?.['url'] == null">Clear</button>
							<p class="mb-0 text-end"><span class="fw-bold">Date:</span> {{
								this.entityData?.['field_sale_date'] | date }}</p>
						</div>
					</div>
				</div>
			</div>

			<!-- Parent/Guardian Signature Section -->
			<div class="row mt-4">
				<div class="col-12">
					<div class="parent-signature p-3 border rounded bg-light" [class.d-none]="!detectSignatureParent && !this._enrollmentEntityData?.['field_parent_guardian_signature']?.[0]?.['url']">
						<p class="fw-bold mb-2">Parent/Guardian Signature (if applicable):</p>
						<div class="signature-container bg-light p-1 border rounded"
							style="min-height: 125px; touch-action: none;">
							<canvas
								*ngIf="this._enrollmentEntityData?.['field_parent_guardian_signature']?.[0]?.['url'] == null"
								width="888" height="125" class="signature-canvas w-100"
								#SignatureParent></canvas>

							<div
								*ngIf="this._enrollmentEntityData?.['field_parent_guardian_signature']?.[0]?.['url']">
								<img class="img-fluid"
									[src]="this._enrollmentEntityData?.['field_parent_guardian_signature'][0]?.['url']" />
							</div>
						</div>
						<div class="d-flex justify-content-between align-items-center mt-2">
							<button class="mt-1" [class.display-none]="!detectSignatureParent"
								type="button" mat-stroked-button (click)="signatureClearParent()"
								*ngIf="this._enrollmentEntityData?.['field_parent_guardian_signature']?.[0]?.['url'] == null">Clear</button>
							<p class="mb-0 text-end"><span class="fw-bold">Date:</span> {{
								this.entityData?.['field_sale_date'] | date }}</p>
						</div>
						<p class="small text-muted mt-2 mb-0">On behalf of my minor child and
							myself, I agree to assume and comply with all the provisions of this
							agreement, including the provision titled
							"Participation & Assumption of Risk" and "Indemnity." I promise to pay
							any financial obligation that my minor child does not pay for any
							reason.</p>
					</div>

					<button *ngIf="!detectSignatureParent && !this._enrollmentEntityData?.['field_parent_guardian_signature']?.[0]?.['url']"
						type="button" mat-stroked-button color="primary" class="mt-2"
						(click)="showParentSignature()">
						Add Parent/Guardian Signature
					</button>
				</div>
			</div>

			<div class="row mt-3 mb-3 g-2">
				<div class="col-12 col-lg-6">
					<button style="background-color: transparent !important; border: none;"
						(click)="printPage(false, true)"
						type="button"
						mat-icon-button
						class="me-1 mb-1"
						matTooltip="Print agreement"
						matTooltipPosition="below"
						aria-label="Print agreement">
						<mat-icon style="color: #1C3F8B;">print</mat-icon>
					</button>
					<button
						[disabled]="(!detectSignatureStudio && !this._enrollmentEntityData?.['field_representative_signature']?.[0]?.['url']) ||
												(!detectSignatureStudent && !this._enrollmentEntityData?.['field_signature']?.[0]?.['url']) ||
												!tosAccepted"
						(click)="onSubmitSignatures('save_and_email')"
						class="me-1" type="button" mat-stroked-button color="primary">
						Save and Email
					</button>
				</div>
				<div class="col-12 col-lg-6">
					<div class="d-flex justify-content-lg-end">
						<button
							[disabled]="(!detectSignatureStudio && !this._enrollmentEntityData?.['field_representative_signature']?.[0]?.['url']) ||
													(!detectSignatureStudent && !this._enrollmentEntityData?.['field_signature']?.[0]?.['url']) ||
													!tosAccepted"
							class="me-1"
							type="button"
							mat-stroked-button
							(click)="onSubmitSignatures('save_and_add')"
							color="primary">
							Save and Add
						</button>
					</div>
				</div>
			</div>

			<!-- Validation message to show what's missing -->
			<div class="row mt-2"
				*ngIf="((!detectSignatureStudio && !this._enrollmentEntityData?.['field_representative_signature']?.[0]?.['url']) ||
								(!detectSignatureStudent && !this._enrollmentEntityData?.['field_signature']?.[0]?.['url']) ||
								!tosAccepted)">
				<div class="col-12">
					<div class="alert alert-warning">
						<strong>Please complete the following before proceeding:</strong>
						<ul class="mb-0 mt-2">
							<li
								*ngIf="!detectSignatureStudio && !this._enrollmentEntityData?.['field_representative_signature']?.[0]?.['url']">Studio
								signature is required</li>
							<li
								*ngIf="!detectSignatureStudent && !this._enrollmentEntityData?.['field_signature']?.[0]?.['url']">Student
								signature is required</li>
							<li *ngIf="!tosAccepted">Terms of Service must be accepted</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="mt-3 d-none">
				<!-- TODO: Display this only when there is a stepper. -->
				<!-- <button class="me-1" mat-button matStepperPrevious>Back</button> -->
				<!-- <button mat-button matStepperNext>Next</button> -->
			</div>
		</form>

	</div>

</div>
